import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/2_card_back_blue_dark/2_card_back_blue_dark"
 * Contains 1 texture(s)
 */
export class CardsBacks2CardBackBlueDarkAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/2_card_back_blue_dark/2_card_back_blue_dark';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '2_blue_dark.png'
    ] as const;
}
